import { CoreUiInteractionEvent, UiInteraction } from "@obg/ngx.core";

import { HeaderAction, TrackingContext } from "../tracking.model";

export const OMS_TRACKING_DATA: UiInteraction = {
	event: CoreUiInteractionEvent.Navigate,
	context: TrackingContext.HeaderInteractionContext,
	data: { ItemClicked: HeaderAction.OmsNotification },
};

export const MAX_MESSAGES_TO_SHOW = 3;
export const MAT_TOOLTIP_CRS_KEY = "general.notifications";
